dvs([9],{

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_application_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jump_js__ = __webpack_require__(85);




new __WEBPACK_IMPORTED_MODULE_0__shared_application_js__["a" /* default */]({
  data: function data() {
    return {
      'paymentmethod': null,
      'price': 0,
      'discount': {
        mode: 'absolute',
        value: 0
      },
      'discountDisplay': '',
      'paymentconfig': [],
      'modifiers': [],
      'modifierID': 0,
      'modifier': {}
    };
  },


  computed: {
    method: function method() {
      var _this = this;

      return this.paymentconfig.find(function (method) {
        return method.value === _this.paymentmethod;
      });
    },
    totalPrice: function totalPrice() {
      var fee = this.method ? this.method.fee : 0;

      var price = this.price;
      price += this.modifierPriceAdjustment;

      if (this.discount.value > 0) {
        switch (this.discount.mode) {
          case 'absolute':
            price -= this.discount.value;
            break;

          case 'percentage':
            price -= this.discount.value / 100 * price;
            break;
        }
      }

      price += fee;

      return Math.max(price, 0);
    },
    modifierPriceAdjustment: function modifierPriceAdjustment() {
      if (typeof this.modifier.price === 'undefined') {
        return 0;
      }

      return this.modifier.price;
    },
    isPaymentRequired: function isPaymentRequired() {
      return this.totalPrice > 0;
    },
    showModifiers: function showModifiers() {
      return this.modifiers.length > 1;
    }
  },

  methods: {
    init: function init() {
      this.setData();
      if (_state.notifications.length) {
        this.scrollToForm();
      }
    },
    setData: function setData() {
      this.price = _state.price;
      this.paymentconfig = _state.paymentconfig;
      this.paymentmethod = _state.paymentmethod;

      this.modifiers = this.processModifiers(_state.modifiers);
      this.modifierID = this.modifiers.length ? this.modifiers[0].id : 0;
    },
    scrollToForm: function scrollToForm() {
      setTimeout(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2_jump_js__["a" /* default */])('.register');
      }, 600);
    },


    checkDiscountCoupon: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function (event) {
      var target = event.target;
      this.updateDiscountCoupon(target);
    }, 500),

    updateDiscountCoupon: function updateDiscountCoupon(target) {
      var _this2 = this;

      var uri = target.getAttribute('data-uri');
      var value = target.value;

      if (value.length < 3) {
        this.discount = {
          mode: 'absolute',
          value: 0
        };
        this.discountDisplay = '';
        return;
      }

      this.$http.post(uri, {
        event: _state.eventSlug,
        code: value
      }).then(function (response) {
        var data = response.data;

        _this2.discount = data.discount;
        _this2.discountDisplay = data.discountDisplay;
      }).catch(function (error) {
        // invalid request / code / combination
        _this2.discount = 0;

        if (error.response) {
          var response = error.response;
          var status = response.status || 422;
          if (status === 404) {
            _this2.discountDisplay = 'code niet bekend';
            return;
          }

          if (status === 422) {
            _this2.discountDisplay = 'korting kan niet worden toegepast';
            return;
          }
        }

        _this2.discountDisplay = '';
      });
    },
    processModifiers: function processModifiers(modifiers) {
      return modifiers.map(function (mod) {
        if (mod.price && mod.price != 0) {
          mod.title += ' (' + mod.priceDisplay + ')';
        }

        return mod;
      });
    },
    updateModifier: function updateModifier(event) {
      var _this3 = this;

      this.modifier = this.modifiers.find(function (mod) {
        return mod.id == _this3.modifierID;
      });
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    this.init();

    this.$nextTick(function () {
      _this4.updateDiscountCoupon(_this4.$refs.discountcode);
    });
  }
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Robert Penner's easeInOutQuad

// find the rest of his easing functions here: http://robertpenner.com/easing/
// find them exported for ES6 consumption here: https://github.com/jaxgeller/ez.js

var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var jumper = function jumper() {
  // private variable cache
  // no variables are created during a jump, preventing memory leaks

  var element = void 0; // element to scroll to                   (node)

  var start = void 0; // where scroll starts                    (px)
  var stop = void 0; // where scroll stops                     (px)

  var offset = void 0; // adjustment from the stop position      (px)
  var easing = void 0; // easing function                        (function)
  var a11y = void 0; // accessibility support flag             (boolean)

  var distance = void 0; // distance of scroll                     (px)
  var duration = void 0; // scroll duration                        (ms)

  var timeStart = void 0; // time scroll started                    (ms)
  var timeElapsed = void 0; // time spent scrolling thus far          (ms)

  var next = void 0; // next scroll position                   (px)

  var callback = void 0; // to call when done scrolling            (function)

  // scroll position helper

  function location() {
    return window.scrollY || window.pageYOffset;
  }

  // element offset helper

  function top(element) {
    return element.getBoundingClientRect().top + start;
  }

  // rAF loop helper

  function loop(timeCurrent) {
    // store time scroll started, if not started already
    if (!timeStart) {
      timeStart = timeCurrent;
    }

    // determine time spent scrolling so far
    timeElapsed = timeCurrent - timeStart;

    // calculate next scroll position
    next = easing(timeElapsed, start, distance, duration);

    // scroll to it
    window.scrollTo(0, next);

    // check progress
    timeElapsed < duration ? window.requestAnimationFrame(loop) // continue scroll loop
    : done(); // scrolling is done
  }

  // scroll finished helper

  function done() {
    // account for rAF time rounding inaccuracies
    window.scrollTo(0, start + distance);

    // if scrolling to an element, and accessibility is enabled
    if (element && a11y) {
      // add tabindex indicating programmatic focus
      element.setAttribute('tabindex', '-1');

      // focus the element
      element.focus();
    }

    // if it exists, fire the callback
    if (typeof callback === 'function') {
      callback();
    }

    // reset time for next jump
    timeStart = false;
  }

  // API

  function jump(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // resolve options, or use defaults
    duration = options.duration || 1000;
    offset = options.offset || 0;
    callback = options.callback; // "undefined" is a suitable default, and won't be called
    easing = options.easing || easeInOutQuad;
    a11y = options.a11y || false;

    // cache starting position
    start = location();

    // resolve target
    switch (typeof target === 'undefined' ? 'undefined' : _typeof(target)) {
      // scroll from current position
      case 'number':
        element = undefined; // no element to scroll to
        a11y = false; // make sure accessibility is off
        stop = start + target;
        break;

      // scroll to element (node)
      // bounding rect is relative to the viewport
      case 'object':
        element = target;
        stop = top(element);
        break;

      // scroll to element (selector)
      // bounding rect is relative to the viewport
      case 'string':
        element = document.querySelector(target);
        stop = top(element);
        break;
    }

    // resolve scroll distance, accounting for offset
    distance = stop - start + offset;

    // resolve duration
    switch (_typeof(options.duration)) {
      // number in ms
      case 'number':
        duration = options.duration;
        break;

      // function passed the distance of the scroll
      case 'function':
        duration = options.duration(distance);
        break;
    }

    // start the loop
    window.requestAnimationFrame(loop);
  }

  // expose only the jump method
  return jump;
};

// export singleton

var singleton = jumper();

/* harmony default export */ __webpack_exports__["a"] = (singleton);


/***/ })

},[230]);


// WEBPACK FOOTER //
// js/events.view.8245b3a0.js